// project imports
// import NavUser from './NavUser';
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <>
      <SimpleBar
        sx={{
          position: 'relative',
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
          },
          '& .simplebar-content:after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '40px',
            pointerEvents: 'none'
          },
          '& .simplebar-scrollbar:before': {
            background: 'transparent'
          }
        }}
      >
        <Navigation />
      </SimpleBar>
    </>
  );
}
